module.exports = __webpack_public_path__ + "img/icon-sb-trash-16x16.45082ac.svg";